import { App, TableProps, Tag, Typography } from 'antd';
import { RiResetLeftFill } from 'react-icons/ri';
import { useParams } from 'react-router-dom';
import { TActionList } from '../../../common';
import { ActionListButton, axiosApi, DataTable } from '../../../core';
import { CurrencyUtils } from '../../../utils/currency';
import { useGetPaymentsQuery } from '../store/customers.api';
import { PaymentStatus } from './PaymentStatus';

const { Text } = Typography;

export const PaymentHistory = () => {
  const { customerId = '' } = useParams();
  const { modal, message } = App.useApp();

  const {
    data: payments,
    isLoading,
    refetch,
  } = useGetPaymentsQuery({ id: customerId });

  const actionItems: TActionList['items'] = [
    {
      key: 'reset-payment',
      label: 'Reset Payment',
      icon: <RiResetLeftFill />,
      action: (record) => {
        modal.confirm({
          content: 'Do you confirm that you want to reset the payment record?',
          onOk: () => {
            const id = record.key;

            axiosApi
              .post(`/payments/${id}/reset`)
              .then(({ status }) => {
                if (status === 200) {
                  message.success('The payment record has been reset.');
                  refetch();
                }
              })
              .catch(
                ({
                  response: {
                    data: { statusCode, message: errorMessage },
                  },
                }) => {
                  if (statusCode === 422) {
                    message.error(errorMessage);
                  }
                },
              );
          },
        });
      },
    },
  ];

  const columns: TableProps['columns'] = [
    {
      title: 'Order ID',
      dataIndex: 'order_id',
      render: (orderId: string) =>
        orderId ? <Tag>{orderId}</Tag> : <Text type="danger">Missing</Text>,
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      render: (paymentAmount: number) =>
        CurrencyUtils().intlFormat({ amount: paymentAmount }),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (status: string) => <PaymentStatus status={status} />,
    },
    {
      title: 'Message',
      dataIndex: 'transaction',
      render: (transaction: Record<string, any>) =>
        transaction?.message || <Text type="danger">--</Text>,
    },
    {
      title: 'Date',
      dataIndex: 'created_at',
      render: (date: string) => new Date(date).toLocaleString(),
    },
    {
      title: 'Actions',
      render: (record) => (
        <ActionListButton items={actionItems} record={record} />
      ),
    },
  ];

  return (
    <DataTable isLoading={isLoading} columns={columns} data={payments || []} />
  );
};
